<template>
    <div id="app">
      <FixedHeader ref="fixedHeaderComponent"/>
      <div class="container">
        <div class="page-container">
          <router-view/>
        </div>

        <div class="footer-container mt-5 pt-5 text-center h5">
          © 2018 radiokids.online
        </div>
      </div>
    </div>
</template>

<script>
import Vue from 'vue'
import FixedHeader from '@/components/Header/FixedHeader'
import RadioPlayer from '@/components/Player/RadioPlayer'

export const RadioPlayerInstance = new Vue(RadioPlayer)

export default {
  name: 'App',
  components: {
    FixedHeader
  }
}
</script>

<style lang="scss" scoped>
  @import "variables.scss";
  @import "compass/css3/images";

  .container {
    max-width: $content-width;
    margin-bottom: 150px;
  }
  .container > hr {
    margin: 30px 0;
  }
  .page-container {
    font-size: 1.5rem;
    font-weight: 200;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue